import { render, staticRenderFns } from "./AccountEmployees.vue?vue&type=template&id=487c7a72"
import script from "./AccountEmployees.vue?vue&type=script&lang=js"
export * from "./AccountEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports